import { useNavigate } from "react-router-dom";

const PD = "'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, sans-serif";

export default function HeroSection() {
  const navigate = useNavigate();

  const scrollToContact = () => {
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image — 의도적 다크 섹션 */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://public.readdy.ai/ai/img_res/22dda7b92b62166b2b2f8c1a9d39df9e.jpg)",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0C0C0E]/70 via-[#0C0C0E]/50 to-[#0C0C0E]/90" />
      <div className="absolute inset-0 bg-[#0C0C0E]/30" />

      {/* Content — 다크 배경 위 흰 텍스트, CSS 오버라이드 방지용 inline style */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-5 text-center pt-24 pb-16 md:pb-20">
        {/* Badge */}
        <div
          className="inline-flex items-center gap-2 bg-white/[0.06] border border-[#4B6CF7]/30 text-[#7A9BFF] text-xs px-4 py-1.5 rounded-full mb-7 md:mb-10"
          style={{ fontFamily: PD }}
        >
          <span className="w-1.5 h-1.5 rounded-full bg-[#4B6CF7] animate-pulse inline-block"></span>
          문화예술 경영 교육의 새로운 기준
        </div>

        {/* Main Headline — inline style로 흰 텍스트 강제 유지 */}
        <h2
          className="font-bold tracking-tight mb-5 md:mb-7"
          style={{ fontFamily: PD, color: "#F2F2F2" }}
        >
          <span className="block text-[2rem] sm:text-4xl md:text-5xl lg:text-6xl mb-3 md:mb-6 leading-tight">
            문화예술 기업 경영을
          </span>
          <span className="block text-[2rem] sm:text-4xl md:text-5xl lg:text-6xl text-transparent bg-clip-text bg-gradient-to-r from-[#7A9BFF] via-[#9BB5FF] to-[#7A9BFF] leading-tight">
            직접 경험하세요
          </span>
        </h2>

        {/* Subheadline */}
        <p
          className="text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-8 md:mb-12 px-2"
          style={{ fontFamily: PD, color: "rgba(255,255,255,0.65)" }}
        >
          K-ArtPEN은 음악 레이블부터 문화재단까지,
          <br className="hidden sm:block" />
          실제 문화예술 기업 경영 환경을 그대로 시뮬레이션합니다.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10 md:mb-16">
          <button
            type="button"
            onClick={() => navigate("/login")}
            className="w-full sm:w-auto bg-[#4B6CF7] hover:bg-[#5B7CF7] text-white font-semibold text-sm md:text-base px-7 md:px-8 py-3 md:py-3.5 rounded-xl transition-all cursor-pointer whitespace-nowrap"
            style={{ fontFamily: PD }}
          >
            무료로 시작하기
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
          <button
            type="button"
            onClick={scrollToContact}
            className="w-full sm:w-auto border hover:bg-white/[0.08] font-medium text-sm md:text-base px-7 md:px-8 py-3 md:py-3.5 rounded-xl transition-all cursor-pointer whitespace-nowrap"
            style={{ fontFamily: PD, backgroundColor: "rgba(255,255,255,0.05)", borderColor: "rgba(255,255,255,0.12)", color: "rgba(255,255,255,0.8)" }}
          >
            <i className="ri-building-line mr-2"></i>기관 도입 문의
          </button>
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-3 gap-3 md:gap-6 max-w-sm md:max-w-lg mx-auto mt-8 md:mt-14">
          {[
            { num: "5가지", label: "기업 유형" },
            { num: "16가지", label: "직무 역할" },
            { num: "36+", label: "시나리오" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div
                className="text-xl md:text-2xl lg:text-3xl font-bold tabular-nums mb-1"
                style={{ fontFamily: PD, color: "#F2F2F2" }}
              >
                {stat.num}
              </div>
              <div style={{ fontFamily: PD, color: "rgba(255,255,255,0.35)", fontSize: "10px" }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1.5 opacity-30">
        <span style={{ color: "rgba(255,255,255,0.7)", fontSize: "10px", fontFamily: PD, textTransform: "uppercase", letterSpacing: "0.1em" }}>
          scroll
        </span>
        <i className="ri-arrow-down-line text-sm animate-bounce" style={{ color: "rgba(255,255,255,0.7)" }}></i>
      </div>
    </section>
  );
}
